'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _rollbarService = require('../../analytics/rollbarService');

var _formActions = require('./formActions');

var _logger = require('../../utils/logger');

var _logger2 = _interopRequireDefault(_logger);

var _errorConstants = require('../../../common/error/errorConstants');

var _rollbarConstants = require('../../analytics/rollbarConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants


// Actions
// Utils
exports.default = function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState,
        form = _ref.form,
        _ref$reportError = _ref.reportError,
        reportError = _ref$reportError === undefined ? true : _ref$reportError,
        sensitive = _ref.sensitive;
    return function (err) {
        var errorMessage = form + ' submission error';
        _logger2.default.error(errorMessage, err, err.response);

        if (!err.response) return Promise.reject(err);

        var errorCode = (0, _lodash.get)(err, 'response.code');
        var error = (0, _lodash.get)(err, 'response.data.error');
        var isClientValidationError = error && error.code === _errorConstants.RESPONSE_ERROR.VALIDATION_FAILURE;

        // Notify rollbar
        var level = isClientValidationError ? _rollbarConstants.ROLLBAR_LEVELS.WARNING : _rollbarConstants.ROLLBAR_LEVELS.ERROR;
        reportError && (0, _rollbarService.manuallyReportError)({ errorMessage: errorMessage, error: err, sensitive: sensitive, level: level, getState: getState });

        var primaryError = undefined;
        var errorRes = undefined;

        // On validation errors respond with a structure that the form can react to
        // But don't show any primary error message to the user
        if (isClientValidationError) {
            errorRes = error.details;
        } else {
            // Need to report these errors to Rollbar and also show the a primary error message on the form.
            errorRes = err;
            primaryError = {
                message: (0, _lodash.get)(error, 'message') || 'Something went wrong, please try again'
            };
        }

        dispatch((0, _formActions.formSubmissionFailed)({
            form: form,
            primaryError: primaryError,
            errorCode: errorCode,
            reportError: reportError
        }));

        return Promise.reject(errorRes);
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/formSubmissionExceptionHandler.js
// module id = 296
// module chunks = 0